module.exports = __webpack_public_path__ + "static/tatianawork7-c927b91a9b41e882980b01d695e0150c.jpeg";